var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-date-picker", {
    staticStyle: {
      height: "38px"
    },
    attrs: {
      value: _vm.value,
      clearable: _vm.clearable,
      type: "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    on: {
      input: _vm.handleInput
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };